// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon{
  display:inline-block;
  text-transform:none;
  letter-spacing:normal;
  overflow-wrap:normal;
  white-space:nowrap;
  direction:ltr;
  fill:currentcolor;
  -webkit-font-smoothing:antialiased;
  text-rendering:optimizelegibility;
}

  .icon__baseline{
    vertical-align:baseline;
  }

  .icon__text-bottom{
    vertical-align:text-bottom;
  }

  .icon__text-top{
    vertical-align:text-top;
  }

  .icon__middle{
    vertical-align:middle;
  }

  .icon__top{
    vertical-align:top;
  }

  .icon__bottom{
    vertical-align:bottom;
  }

  .icon__sub{
    vertical-align:sub;
  }

  .icon__extra-small{
    width:0.75rem;
    height:0.75rem;
  }

  .icon__extra-small--gap-left-three-quarter{
    margin-left:0.25rem;
  }

  .icon__extra-small--gap-left-regular{
    margin-left:0.375rem;
  }

  .icon__extra-small--gap-left-small{
    margin-left:0.1875rem;
  }

  .icon__extra-small--gap-left-tiny{
    margin-left:0.09375rem;
  }

  .icon__extra-small--gap-three-quarter{
    margin-right:0.25rem;
  }

  .icon__extra-small--gap-regular{
    margin-right:0.375rem;
  }

  .icon__extra-small--gap-small{
    margin-right:0.1875rem;
  }

  .icon__text{
    width:1rem;
    height:1rem;
  }

  .icon__text--gap-left-three-quarter{
    margin-left:0.33333rem;
  }

  .icon__text--gap-left-regular{
    margin-left:0.5rem;
  }

  .icon__text--gap-left-small{
    margin-left:0.25rem;
  }

  .icon__text--gap-left-tiny{
    margin-left:0.125rem;
  }

  .icon__text--gap-three-quarter{
    margin-right:0.33333rem;
  }

  .icon__text--gap-regular{
    margin-right:0.5rem;
  }

  .icon__text--gap-small{
    margin-right:0.25rem;
  }

  .icon__small{
    width:1.125rem;
    height:1.125rem;
  }

  .icon__small--gap-left-three-quarter{
    margin-left:0.375rem;
  }

  .icon__small--gap-left-regular{
    margin-left:0.5625rem;
  }

  .icon__small--gap-left-small{
    margin-left:0.28125rem;
  }

  .icon__small--gap-left-tiny{
    margin-left:0.14063rem;
  }

  .icon__small--gap-three-quarter{
    margin-right:0.375rem;
  }

  .icon__small--gap-regular{
    margin-right:0.5625rem;
  }

  .icon__small--gap-small{
    margin-right:0.28125rem;
  }

  .icon__regular{
    width:1.25rem;
    height:1.25rem;
  }

  .icon__regular--gap-left-three-quarter{
    margin-left:0.41667rem;
  }

  .icon__regular--gap-left-regular{
    margin-left:0.625rem;
  }

  .icon__regular--gap-left-small{
    margin-left:0.3125rem;
  }

  .icon__regular--gap-left-tiny{
    margin-left:0.15625rem;
  }

  .icon__regular--gap-three-quarter{
    margin-right:0.41667rem;
  }

  .icon__regular--gap-regular{
    margin-right:0.625rem;
  }

  .icon__regular--gap-small{
    margin-right:0.3125rem;
  }

  .icon__medium{
    width:1.375rem;
    height:1.375rem;
  }

  .icon__medium--gap-left-three-quarter{
    margin-left:0.45833rem;
  }

  .icon__medium--gap-left-regular{
    margin-left:0.6875rem;
  }

  .icon__medium--gap-left-small{
    margin-left:0.34375rem;
  }

  .icon__medium--gap-left-tiny{
    margin-left:0.17188rem;
  }

  .icon__medium--gap-three-quarter{
    margin-right:0.45833rem;
  }

  .icon__medium--gap-regular{
    margin-right:0.6875rem;
  }

  .icon__medium--gap-small{
    margin-right:0.34375rem;
  }

  .icon__large{
    width:1.5rem;
    height:1.5rem;
  }

  .icon__large--gap-left-three-quarter{
    margin-left:0.5rem;
  }

  .icon__large--gap-left-regular{
    margin-left:0.75rem;
  }

  .icon__large--gap-left-small{
    margin-left:0.375rem;
  }

  .icon__large--gap-left-tiny{
    margin-left:0.1875rem;
  }

  .icon__large--gap-three-quarter{
    margin-right:0.5rem;
  }

  .icon__large--gap-regular{
    margin-right:0.75rem;
  }

  .icon__large--gap-small{
    margin-right:0.375rem;
  }

  .icon__extra-large{
    width:1.625rem;
    height:1.625rem;
  }

  .icon__extra-large--gap-left-three-quarter{
    margin-left:0.54167rem;
  }

  .icon__extra-large--gap-left-regular{
    margin-left:0.8125rem;
  }

  .icon__extra-large--gap-left-small{
    margin-left:0.40625rem;
  }

  .icon__extra-large--gap-left-tiny{
    margin-left:0.20313rem;
  }

  .icon__extra-large--gap-three-quarter{
    margin-right:0.54167rem;
  }

  .icon__extra-large--gap-regular{
    margin-right:0.8125rem;
  }

  .icon__extra-large--gap-small{
    margin-right:0.40625rem;
  }

  .icon__title{
    width:2rem;
    height:2rem;
  }

  .icon__title--gap-left-three-quarter{
    margin-left:0.66667rem;
  }

  .icon__title--gap-left-regular{
    margin-left:1rem;
  }

  .icon__title--gap-left-small{
    margin-left:0.5rem;
  }

  .icon__title--gap-left-tiny{
    margin-left:0.25rem;
  }

  .icon__title--gap-three-quarter{
    margin-right:0.66667rem;
  }

  .icon__title--gap-regular{
    margin-right:1rem;
  }

  .icon__title--gap-small{
    margin-right:0.5rem;
  }

  .icon__double{
    width:2.5rem;
    height:2.5rem;
  }

  .icon__double--gap-left-three-quarter{
    margin-left:0.83333rem;
  }

  .icon__double--gap-left-regular{
    margin-left:1.25rem;
  }

  .icon__double--gap-left-small{
    margin-left:0.625rem;
  }

  .icon__double--gap-left-tiny{
    margin-left:0.3125rem;
  }

  .icon__double--gap-three-quarter{
    margin-right:0.83333rem;
  }

  .icon__double--gap-regular{
    margin-right:1.25rem;
  }

  .icon__double--gap-small{
    margin-right:0.625rem;
  }

  .icon__jumbo{
    width:2.875rem;
    height:2.875rem;
  }

  .icon__jumbo--gap-left-three-quarter{
    margin-left:0.95833rem;
  }

  .icon__jumbo--gap-left-regular{
    margin-left:1.4375rem;
  }

  .icon__jumbo--gap-left-small{
    margin-left:0.71875rem;
  }

  .icon__jumbo--gap-left-tiny{
    margin-left:0.35938rem;
  }

  .icon__jumbo--gap-three-quarter{
    margin-right:0.95833rem;
  }

  .icon__jumbo--gap-regular{
    margin-right:1.4375rem;
  }

  .icon__jumbo--gap-small{
    margin-right:0.71875rem;
  }

  .icon__max{
    width:5.25rem;
    height:5.25rem;
  }

  .icon__max--gap-left-three-quarter{
    margin-left:1.75rem;
  }

  .icon__max--gap-left-regular{
    margin-left:2.625rem;
  }

  .icon__max--gap-left-small{
    margin-left:1.3125rem;
  }

  .icon__max--gap-left-tiny{
    margin-left:0.65625rem;
  }

  .icon__max--gap-three-quarter{
    margin-right:1.75rem;
  }

  .icon__max--gap-regular{
    margin-right:2.625rem;
  }

  .icon__max--gap-small{
    margin-right:1.3125rem;
  }

  .icon__brand{
    fill:#ef3e39;
  }

  .icon__brand-darker{
    fill:#bf322e;
  }

  .icon__primary{
    fill:#206dd2;
  }

  .icon__secondary{
    fill:#218372;
  }

  .icon__grey{
    fill:#424242;
  }

  .icon__grey-light,
  .icon__grey-40{
    fill:#707070;
  }

  .icon__grey-20{
    fill:#e5e6e6;
  }

  .icon__grey-30{
    fill:#ababab;
  }

  .icon__grey-lighter{
    fill:#d4d4d4;
  }

  .icon__white{
    fill:#fff;
  }

  .icon__blueberry{
    fill:#128ce8;
  }

  .icon__mint{
    fill:#1ea385;
  }

  .icon__apple{
    fill:#52a833;
  }

  .icon__lemon{
    fill:#fad143;
  }

  .icon__mandarin{
    fill:#db6b16;
  }

  .icon__watermelon{
    fill:#ca4a55;
  }

  .icon__grape{
    fill:#8d4fff;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
